<div>
    <ul>
        <slot />
    </ul>
</div>

<style>
    ul {
        width: 210px;
        list-style-type: none;
        margin: 0;
        padding: 0;
    }
</style>
